var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"base-form-input"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),(_vm.optional)?_c('span',{staticClass:"detail"},[_vm._v(_vm._s('Optional'))]):_vm._e()]),_vm._t("default"),_c('p',{staticClass:"hint"},[_vm._t("hint")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }